import Vue from 'vue'
import { HTTP } from '../../../../utils/httpCommonUtil'
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import { getRestParamErrorMessage, getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';
import flatPickr from 'vue-flatpickr-component';
import format from 'date-fns/format'
import {adminRoles} from '@/enums/userRolesEnum'
import FacilityControl from '@/componentsReusable/FacilityControl.vue'
import UploadControl from '@/componentsReusable/UploadControl.vue'
import GenericModal from '@/componentsReusable/genericModal.vue'
import MaskedInput from 'vue-text-mask'
import emailMask from 'text-mask-addons/dist/emailMask'
import facilityEventHub from '@/components/facility/FacilityEventHub';
import {globalObject} from "@/utils/proxyDataUtil";
import communication from "@/store/modules/communication";
import {ViewStateType} from "@/enums/ViewStateType";

export default Vue.component('facility-contacts-card', {
  name: 'FacilityContactsCard',
  data () {
    let emptyArray: Array<any> = [];
    return {
      cardExpanded: false,
      loadingInitialData: false,
      savingNewContact: false,
      facilityContacts: emptyArray,
      isAuthorizedToDelete: false,
      showConfirmationModal: false,
      showDeleteSpecialtyConfirmationModal: false,
      pendingDeleteContact: null,
      pendingDeleteSpecialty: null,
      pendingFacilityContact: null,
      emailMask: emailMask,
      systemSpecialties: [],
      systemContactTypes: [] as any[],
      savingNewSpecialty: false,
      facilityInfo: {} as any
    }
  },
  components: {
    flatPickr,
    BallPulseLoader,
    VueSimpleSpinner,
    FacilityControl,
    UploadControl,
    GenericModal,
    MaskedInput
  },
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole'](adminRoles);
  },
  created: function () {
    this.getFacilityInfo()
    facilityEventHub.$on('SPECIALTY_ADDED_OR_REMOVED', this.getFacilitySpecialties)
  },
  beforeDestroy: function () {
    facilityEventHub.$off('SPECIALTY_ADDED_OR_REMOVED', this.getFacilitySpecialties)
  },
  filters: {
    dateformat (dateISO: string) {
      let tempString: string = format(dateISO, 'M.D.YY');
      return tempString;
    },
    phoneNumber (phoneNumber: string) {
      let formattedPhoneNumber = phoneNumber;
      if (phoneNumber && phoneNumber.length) {
        let phoneNumberArray = phoneNumber.match(/(\d)?(\d\d\d)?(\d\d\d)(\d\d\d\d)$/);
        if (!phoneNumberArray) { return formattedPhoneNumber; }
        formattedPhoneNumber = phoneNumberArray.length ? '' : formattedPhoneNumber;
        for (let i = 1; i < phoneNumberArray.length; i++) {
          if (phoneNumberArray[i]) {
            formattedPhoneNumber += phoneNumberArray[i] + '.';
          }
        }
        formattedPhoneNumber = formattedPhoneNumber.slice(0,formattedPhoneNumber.length - 1);
      } else {
        formattedPhoneNumber = 'NA';
      }
      return formattedPhoneNumber;
    }
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getFacilityContacts()
        this.getFacilitySpecialties()
        this.getSystemContactTypes()
      }
    },
    getFacilitySpecialties () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 500);
      HTTP.get('/api/facilities/'+ this.$route.params.facilityId +'/specialty-types')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Specialties.");
        }
        self.systemSpecialties = response.data.data;
      })
      .catch(function () {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving System Specialties.'
        });
      })
    },
    getSystemContactTypes () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 500);
      HTTP.get('/api/facility-contact-types')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Contact Types.");
        }
        self.systemContactTypes = response.data.data;
      })
      .catch(function () {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving System Contact Types.'
        });
      })
    },
    getFacilityContacts () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/contacts')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Facility Contacts.");
        }
        let freshFacilityContacts = response.data.data;
        freshFacilityContacts.forEach( function (facilityContact: any) {
          facilityContact.isEditing = false;
          facilityContact.isNew = false;
          facilityContact.updatingData = false;
          facilityContact.facilityContactTypeIdErrorMessage = '';
        });

        self.facilityContacts = freshFacilityContacts;
      })
      .catch(function () {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Facility Contacts.'
        });
      })
    },
    getFacilityInfo () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/general-information')
        .then(function (response) {
          clearTimeout(showLoadingSpinnerTimeout);
          self.loadingInitialData = false;
          if (!response.data || !response.data.data) {
            throw new Error("Error retrieving Facility Contacts.");
          }
          self.facilityInfo = response.data.data;
        })
        .catch(function () {
          console.log('response Error!');
          clearTimeout(showLoadingSpinnerTimeout);
          self.loadingInitialData = false;
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: 'An error occurred retrieving Facility Info.'
          });
        })
    },
    facilitySelected (contact: any, facility: any) {
      contact.facilityId = facility.id;
      contact.facilityName = facility.name;
    },
    saveContact (newContact: any) {
      let self = this
      self.savingNewContact = true;
      HTTP.post('/api/facilities/' + this.$route.params.facilityId + '/contacts', newContact)
      .then(function (response) {
        self.savingNewContact = false;
        newContact.isEditing = false;
        self.getFacilityContacts();
      })
      .catch(function (error) {
        self.savingNewContact = false;

        newContact.facilityContactIdErrorMessage = getRestParamErrorMessage(error,'facilityContactId');
        newContact.facilityFacilityContactAssocIdErrorMessage = getRestParamErrorMessage(error,'facilityFacilityContactAssocId');
        newContact.firstNameErrorMessage = getRestParamErrorMessage(error,'firstName');
        newContact.lastNameErrorMessage = getRestParamErrorMessage(error,'lastName');
        newContact.generalTitleErrorMessage = getRestParamErrorMessage(error,'generalTitle');
        newContact.noteErrorMessage = getRestParamErrorMessage(error,'note');
        newContact.phoneOfficeErrorMessage = getRestParamErrorMessage(error,'phoneOffice');
        newContact.phoneOfficeExtErrorMessage = getRestParamErrorMessage(error,'phoneOfficeExt');
        newContact.phoneCellErrorMessage = getRestParamErrorMessage(error,'phoneCell');
        newContact.emailErrorMessage = getRestParamErrorMessage(error,'email');
        newContact.activeErrorMessage = getRestParamErrorMessage(error,'active');
        newContact.isVeteranErrorMessage = getRestParamErrorMessage(error,'veteran');
        newContact.receiveSMSBroadcastErrorMessage = getRestParamErrorMessage(error,'receiveSMSBroadcast');
        newContact.receiveEmailBroadcastErrorMessage = getRestParamErrorMessage(error,'receiveEmailBroadcast');
        newContact.facilityContactTypeIdErrorMessage = getRestParamErrorMessage(error,'facilityContactTypeId');

        if (
          !newContact.facilityContactIdErrorMessage.length &&
          !newContact.facilityFacilityContactAssocIdErrorMessage.length &&
          !newContact.firstNameErrorMessage.length &&
          !newContact.lastNameErrorMessage.length &&
          !newContact.generalTitleErrorMessage.length &&
          !newContact.noteErrorMessage.length &&
          !newContact.phoneOfficeErrorMessage.length &&
          !newContact.phoneOfficeExtErrorMessage.length &&
          !newContact.phoneCellErrorMessage.length &&
          !newContact.emailErrorMessage.length &&
          !newContact.activeErrorMessage.length &&
          !newContact.receiveSMSBroadcastErrorMessage.length &&
          !newContact.receiveEmailBroadcastErrorMessage.length &&
          !newContact.facilityContactTypeIdErrorMessage.length ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Saving',
            text: generalError ? generalError : 'An error occurred saving facility contact.',
          });
        }

      })
    },
    updateContact (updatedContact: any) {
      let self = this
      updatedContact.updatingData = true;
      HTTP.put('/api/facilities/' + this.$route.params.facilityId + '/contacts', updatedContact)
      .then(function (response) {
        updatedContact.updatingData = false;
        updatedContact.isEditing = false;
        self.getFacilityContacts();
      })
      .catch(function (error) {
        updatedContact.updatingData = false;

        updatedContact.facilityContactIdErrorMessage = getRestParamErrorMessage(error,'facilityContactId');
        updatedContact.facilityFacilityContactAssocIdErrorMessage = getRestParamErrorMessage(error,'facilityFacilityContactAssocId');
        updatedContact.firstNameErrorMessage = getRestParamErrorMessage(error,'firstName');
        updatedContact.lastNameErrorMessage = getRestParamErrorMessage(error,'lastName');
        updatedContact.generalTitleErrorMessage = getRestParamErrorMessage(error,'generalTitle');
        updatedContact.noteErrorMessage = getRestParamErrorMessage(error,'note');
        updatedContact.phoneOfficeErrorMessage = getRestParamErrorMessage(error,'phoneOffice');
        updatedContact.phoneOfficeExtErrorMessage = getRestParamErrorMessage(error,'phoneOfficeExt');
        updatedContact.phoneCellErrorMessage = getRestParamErrorMessage(error,'phoneCell');
        updatedContact.emailErrorMessage = getRestParamErrorMessage(error,'email');
        updatedContact.activeErrorMessage = getRestParamErrorMessage(error,'active');
        updatedContact.receiveSMSBroadcastErrorMessage = getRestParamErrorMessage(error,'receiveSMSBroadcast');
        updatedContact.receiveEmailBroadcastErrorMessage = getRestParamErrorMessage(error,'receiveEmailBroadcast');
        updatedContact.facilityContactTypeIdErrorMessage = getRestParamErrorMessage(error,'facilityContactTypeId');

        if (
          !updatedContact.facilityContactIdErrorMessage.length &&
          !updatedContact.facilityFacilityContactAssocIdErrorMessage.length &&
          !updatedContact.firstNameErrorMessage.length &&
          !updatedContact.lastNameErrorMessage.length &&
          !updatedContact.generalTitleErrorMessage.length &&
          !updatedContact.noteErrorMessage.length &&
          !updatedContact.phoneOfficeErrorMessage.length &&
          !updatedContact.phoneOfficeExtErrorMessage.length &&
          !updatedContact.phoneCellErrorMessage.length &&
          !updatedContact.emailErrorMessage.length &&
          !updatedContact.activeErrorMessage.length &&
          !updatedContact.receiveSMSBroadcastErrorMessage.length &&
          !updatedContact.receiveEmailBroadcastErrorMessage.length &&
          !updatedContact.facilityContactTypeIdErrorMessage.length ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Updating',
            text: generalError ? generalError : 'An error occurred updating contact.',
            // duration: 5000
          });
        }

      })
    },
    deleteConfirmed (deleteContact: any) {
      this.showConfirmationModal = false;
      this.deleteContact(this.pendingDeleteContact, true);
    },
    deleteContact (deleteContact: any, bypassDeleteConfirmation: boolean = false) {
      // To prevent a double submit
      if (deleteContact.updatingData) { console.log("returning."); return ; }

      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showConfirmationModal = true;
        this.pendingDeleteContact = deleteContact;
        return;
      } else {
        this.pendingDeleteContact = null;
      }

      let self = this
      deleteContact.updatingData = true;
      HTTP.delete('/api/facilities/' + this.$route.params.facilityId + '/contacts/' + deleteContact.facilityContactId)
      .then(function (response) {
        deleteContact.updatingData = false;
        deleteContact.isEditing = false;
        self.getFacilityContacts();
      })
      .catch(function (error) {
        deleteContact.updatingData = false;
        let generalError = getRestResponseErrorMessage(error);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Deleting',
          text: generalError ? generalError : 'An error occurred deleting facility contact.',
        });
      })
    },
    getSpecialtyName (specialtyId: any, specialtyList: any) {
      let specialtyName;
      specialtyList.forEach(function (specialty: any) {
        if (specialty.id === specialtyId) {
          specialtyName = specialty.specialty;
        }
      })
      return specialtyName;
    },
    saveSpecialty (newSpecialty: any) {
      let self = this
      self.savingNewSpecialty = true;

      newSpecialty.specialtyIdErrorMessage = null;
      newSpecialty.facilityContactTypeIdErrorMessage = null;

      HTTP.post('/api/facilities/' + newSpecialty.facilityId + '/contacts/' + newSpecialty.facilityContactId + '/specialties', newSpecialty)
      .then(function (response) {
        self.savingNewSpecialty = false;
        newSpecialty.isEditing = false;
        newSpecialty.isNew = false;
        newSpecialty.specialtyName = self.getSpecialtyName(newSpecialty.specialtyId, self.systemSpecialties);

        // Broadcast, to whoever is listening, that a new Facility Contact Specialty has been saved
        facilityEventHub.$emit('SPECIALTY_CONTACT_CHANGE');

        // self.getFacilityContacts();
        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Successfully Created',
          text: 'Successfully created Facility Contact Specialty.',
        });
      })
      .catch(function (error) {
        self.savingNewSpecialty = false;

        newSpecialty.specialtyIdErrorMessage = getRestParamErrorMessage(error,'specialtyId');
        newSpecialty.facilityContactTypeIdErrorMessage = getRestParamErrorMessage(error,'facilityContactTypeId');

        if (
          !newSpecialty.specialtyIdErrorMessage.length &&
          !newSpecialty.facilityContactTypeIdErrorMessage.length
        ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Saving',
            text: generalError ? generalError : 'An error occurred saving facility contact specialty.',
          });
        }

      })
    },
    updateSpecialty (updatedSpecialty: any) {
      let self = this
      updatedSpecialty.updatingData = true;
      HTTP.put('/api/facilities/' + updatedSpecialty.facilityId + '/contacts/' + updatedSpecialty.facilityContactId + '/specialties', updatedSpecialty)
      .then(function (response) {
        updatedSpecialty.updatingData = false;
        updatedSpecialty.isEditing = false;

        // Broadcast, to whoever is listening, that a new Facility Contact Specialty has been updated
        facilityEventHub.$emit('SPECIALTY_CONTACT_CHANGE');

        // self.getFacilityContacts();
        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Successfully Updated',
          text: 'Successfully updated Facility Contact Specialty.',
        });
      })
      .catch(function (error) {
        updatedSpecialty.updatingData = false;

        updatedSpecialty.specialtyIdErrorMessage = getRestParamErrorMessage(error,'specialtyId');

        if (
          !updatedSpecialty.specialtyIdErrorMessage.length
        ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Updating',
            text: generalError ? generalError : 'An error occurred updating facility contact specialty.',
          });
        }

      })
    },
    deleteSpecialtyConfirmed (deleteContact: any) {
      this.showDeleteSpecialtyConfirmationModal = false;
      this.deleteSpecialty(this.pendingDeleteSpecialty, true, this.pendingFacilityContact);
    },
    deleteSpecialty (deleteSpecialty: any, bypassDeleteConfirmation: boolean = false, facilityContact: any) {
      // To prevent a double submit
      if (deleteSpecialty.updatingData) { console.log("returning."); return ; }

      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showDeleteSpecialtyConfirmationModal = true;
        this.pendingDeleteSpecialty = deleteSpecialty;
        this.pendingFacilityContact = facilityContact;
        return;
      } else {
        this.pendingDeleteSpecialty = null;
        this.pendingFacilityContact = null;
      }

      let self = this
      deleteSpecialty.updatingData = true;
      HTTP.delete('/api/facilities/' + this.$route.params.facilityId + '/contacts/' + deleteSpecialty.facilityContactId + '/specialties/' + deleteSpecialty.specialtyId)
      .then(function (response) {
        deleteSpecialty.updatingData = false;
        deleteSpecialty.isEditing = false;
        deleteSpecialty.hasBeenDeleted = true;

        // Broadcast, to whoever is listening, that a new Facility Contact Specialty has been deleted
        facilityEventHub.$emit('SPECIALTY_CONTACT_CHANGE');

        // self.getFacilityContacts();
        // Remove this specialty from the specialties list
        self.removeSpecialtyFromFacilityContact(deleteSpecialty, facilityContact);
        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Successfully Deleted',
          text: 'Successfully deleted Facility Contact Specialty.',
          // duration: 5000
        });
      })
      .catch(function (error) {
        console.log('error');
        console.log(error);
        deleteSpecialty.updatingData = false;
        let generalError = getRestResponseErrorMessage(error);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Deleting',
          text: generalError ? generalError : 'An error occurred deleting facility contact specialty.',
          // duration: 5000
        });
      })
    },
    removeSpecialtyFromFacilityContact (specialtyToRemove: any, facilityContact: any) {
      let indexesToDelete: any = [];
      facilityContact.specialties.forEach(function (specialty: any, index: any) {
        if (specialty.hasBeenDeleted) {
          indexesToDelete.push(index);
        }
      });
      indexesToDelete.forEach(function (indx: number) {
        facilityContact.specialties.splice(indx,1);
      })
    },
    toggleEditContact (contact: any) {
      let selectedCredId = contact.contactId;
      // Collapse any editing contacts
      // Delete any existing "new" contacts
      let indexesToDelete: any = [];
      this.facilityContacts.forEach(function (contact, index) {
        if (contact.isNew) {
          indexesToDelete.push(index);
        }
        if (selectedCredId !== contact.contactId) {
          contact.isEditing = false;
        }
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.facilityContacts.splice(indx,1);
      })
      contact.isEditing = !contact.isEditing;
    },
    addContact () {
      // Collapse any editing contacts
      // Delete any existing "new" contacts
      let indexesToDelete: any = [];
      this.facilityContacts.forEach(function (contact, index) {
        if (contact.isNew) {
          indexesToDelete.push(index);
        }
        contact.isEditing = false;
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.facilityContacts.splice(indx,1);
      })

      this.facilityContacts.unshift(
        {
          "facilityContactId": null,
          "facilityFacilityContactAssocId": null,
          "firstName": null,
          "lastName": null,
          "generalTitle": null,
          "note": null,
          "phoneOffice": null,
          "phoneOfficeExt": null,
          "phoneCell": null,
          "email": null,
          "active": false,
          "receiveSMSBroadcast": true,
          "receiveEmailBroadcast": true,
          "isEditing": true,
          "isNew": true,
          "updatingData": false,
        }
      );
    },
    cancel (contact: any) {
      contact.isEditing = false;
      if (contact.isNew) {
        // Allow the editing UI to collapse before removing it from the array.
        let self = this;
        setTimeout(function () {
          self.facilityContacts.shift();
        }, 300);
      } else {
        this.getFacilityContacts();
      }
    },
    addSpecialty (facilityContact: any) {
      // Collapse any editing specialties
      // Delete any existing "new" specialties
      let indexesToDelete: any = [];
      facilityContact.specialties.forEach(function (specialty: any, index: number) {
        if (specialty.isNew) {
          indexesToDelete.push(index);
        }
        specialty.isEditing = false;
      });
      indexesToDelete.forEach(function (indx: number) {
        facilityContact.specialties.splice(indx,1);
      })

      facilityContact.specialties.push(
        {
          "facilityId": facilityContact.facilityId,
          "facilityContactId": facilityContact.facilityContactId,
          "specialtyName": null,
          "specialtyId": null,
          "facilityContactTypeId": null,
          "receiveInvoices": false,
          "receiveShiftEmails": false,
          "isEditing": true,
          "isNew": true,
          "updatingData": false,
        }
      );
    },
    cancelSpecialty (facilityContact: any) {
      let indexesToDelete: any = [];
      facilityContact.specialties.forEach(function (specialty: any, index: Number) {
        if (specialty.isNew) { indexesToDelete.push(index); }
      });
      indexesToDelete.forEach(function (indx: number) {
        facilityContact.specialties.splice(indx,1);
      })
    },
    onCopy (param: any) {
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Successfully Copied',
        text: 'Text ' + param.text + ' has been copied.',
        // duration: 5000
      });
    },
    onError (param: any) {
      console.log('Error!');
      console.log(param);
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Copying',
        text: 'Something went wrong copying to your clipboard.',
        // duration: 5000
      });
    },
    contactTypeToName (contactTypeId: number) {
      const matchingContactType = this.systemContactTypes.filter(contactType => contactType.id === contactTypeId);
      if (matchingContactType.length) {
        return matchingContactType[0].name;
      }
      return '';
    },
    async setFacilityContactsState() {
      globalObject.variable1 = communication;
      await this.$store.dispatch('viewState/updateViewState', {
        name: ViewStateType.COMMUNICATION_SELECTED_RECEIVER,
        value: {text:"Facility Contacts",id:2, bulletClass:"nav-circle background-red"}
      });
      await this.$store.dispatch('viewState/updateViewState', {
        name: ViewStateType.COMMUNICATION_SELECTED_CAMPAIGN,
        value: 0
      });
    },
    async setTextsState() {
      await this.$store.dispatch('viewState/updateViewState', {
        name: ViewStateType.COMMUNICATION_SELECTED_MESSAGE_TYPE,
        value: {text: "Texts", id: 1, bulletClass: ""}
      });
    },
    async setEmailsState() {
      await this.$store.dispatch('viewState/updateViewState', {
        name: ViewStateType.COMMUNICATION_SELECTED_MESSAGE_TYPE,
        value: {text: "Emails", id: 2, bulletClass: ""}
      });
    },
    async goToFacilityContactTexts(contact :any) {
      await this.setTextsState()
      await this.setFacilityContactsState();
      this.$router.push({name: 'Communications', params: { facilityContactId: contact.facilityContactId, facilityContactName: `${contact.firstName} ${contact.lastName}` }});
    },
    async goToFacilityContactEmails(contact :any) {
      await this.setEmailsState()
      await this.setFacilityContactsState();
      this.$router.push({name: 'Communications', params: { facilityContactId: contact.facilityContactId, facilityContactName: `${contact.firstName} ${contact.lastName}`}});
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/facility/cards/facilityContacts/FacilityContactsCard.ts